<template>
  <div class="c-outages-map">
    <div id="projects-map" class="c-maps__map"></div>

    <GmapMap
      v-if="google"
      ref="gmap"
      :center="mapConfig.center"
      @center_changed="updateCenter"
      @zoom_changed="updateZoom"
      :zoom="mapConfig.zoom"
      @idle="sync"
      :options="{
        fullscreenControl: false,
        panControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        zoomControl: false,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
      }"
      style="width: 100%; height: 100%"
    >
      <gmap-cluster>
        <gmap-marker
          v-for="outage in getAllFilteredOutages"
          :key="outage.type + outage.id"
          :position="outage.location"
          :clickable="true"
          :icon="{
            url: getMarkerIcon(outage),
            scaledSize: new google.maps.Size(28, 46),
          }"
          @click="markerClick(outage)"
        >
        </gmap-marker>
      </gmap-cluster>
    </GmapMap>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
// https://github.com/diegoazh/gmap-vue/
import { getGoogleMapsAPI } from "gmap-vue";
import { mapGetters } from "vuex";
import { eventBus } from "../utils/event-bus.js";

export default {
  data() {
    return {};
  },
  created() {
    this.sync();
    eventBus.$on("gmap-pan-to", this.gmapPanTo);
    eventBus.$on("gmap-fit-bounds", this.gmapFitBounds);
  },
  components: {},
  async mounted() {
    //this will force the gmap to wait until google is ready
    await this.$gmapApiPromiseLazy().then((google) => {
      console.log("Google Maps API loaded");

      this.$nextTick(() => {
        if (!this.lvOutagesEnabled || !this.lvOutagesGeoJson) {
          return;
        }
        const map = this.$refs.gmap.$mapObject;
        map.data.addGeoJson(this.lvOutagesGeoJson);

        this.setVisibilityLVOutages(this.filterOption == "lv");

        map.data.addListener("click", (event) => {
          console.log("Feature clicked:", event.feature.getProperty("id"));
          this.$store.commit("updateField", {
            path: "lvOutageSelectedLocation",
            value: event.feature.getProperty("id"),
          });
          //this is the breakpoint that the map switches to mobile view - make sure it matches the css
          if (window.matchMedia(this.matchMediaString).matches) {
            this.outagePageView = "list";
          }
        });
      });
    });
  },
  computed: {
    ...mapFields([
      "filterMarkerSelectedLocation",
      "outagePageView",
      "mapConfig",
      "searchText",
      "matchMediaString",
      "lvOutagesEnabled",
      "lvOutagesGeoJson",
      "filterOption",
    ]),
    ...mapGetters(["getAllFilteredOutages", "getMarkerIcon"]),
    // this will return the google object for use in config and other sources
    google: getGoogleMapsAPI,
  },
  watch: {
    filterOption(newVal) {
      if (newVal === "lv") {
        this.setVisibilityLVOutages(true);
      } else {
        this.setVisibilityLVOutages(false);
      }
    },
  },
  methods: {
    setVisibilityLVOutages(visible) {
      const map = this.$refs.gmap.$mapObject;

      map.data.setStyle((feature) => {
        // Assuming each feature has a 'status' property (you can adjust this based on your actual data structure)
        const status = feature.getProperty("csvStatus");

        // Define custom colors based on the status
        let fillColor, strokeColor;
        switch (status) {
          case "All Restored":
            fillColor = "#83c07f";
            strokeColor = "#808080";
            break;
          case "In Progress":
            fillColor = "#FDB930";
            strokeColor = "#808080";
            break;
          case "Not Started":
            fillColor = "#FD6830";
            strokeColor = "#808080";
            break;
          default:
            //No LV faults reported
            fillColor = "transparent";
            strokeColor = "#808080";
        }

        return {
          fillColor: fillColor,
          strokeColor: strokeColor,
          fillOpacity: 0.8,
          strokeWeight: 0.5,
          visible: visible,
        };
      });
    },
    gmapPanTo(location) {
      this.$refs.gmap.panTo(location);
      this.mapConfig.reportedZoom = 17;
      this.mapConfig.zoom = 17;
    },
    gmapFitBounds(bounds) {
      this.$refs.gmap.fitBounds(bounds);
    },
    updateCenter(latLng) {
      this.mapConfig.reportedCenter = {
        lat: latLng.lat(),
        lng: latLng.lng(),
      };
    },
    updateZoom(zoom) {
      this.mapConfig.reportedZoom = zoom;
    },
    sync() {
      //we need to track two sets of data points, this is so we don't try redraw evertime one of these values changes
      this.mapConfig.center = this.mapConfig.reportedCenter;
      this.mapConfig.zoom = this.mapConfig.reportedZoom;
    },
    markerClick(marker) {
      //get all markers where the location lat and long is the same as the current marker clicked
      this.filterMarkerSelectedLocation = marker.location;
      this.searchText = "";

      //this is the breakpoint that the map switches to mobile view - make sure it matches the css
      if (window.matchMedia(this.matchMediaString).matches) {
        this.outagePageView = "list";
      }
    },
  },
};
</script>

<style lang="scss"></style>
